import getCanvasHeight from './getCanvasHeight';

const resizeRendererToDisplaySize = (renderer: any) => {
  const canvas = renderer.domElement;
  const width = window.innerWidth;

  const height = getCanvasHeight();
  const needResize = canvas.width !== width || canvas.height !== height;

  if (needResize) {
    renderer.setSize(width, height, false);
  }

  return needResize;
};

const render = ({
  camera,
  intersected,
  mouse,
  raycaster,
  renderer,
  scene,
}: {
  camera: any;
  intersected: any;
  mouse: any;
  raycaster: any;
  renderer: any;
  scene: any;
}): void => {
  if (resizeRendererToDisplaySize(renderer)) {
    const height = getCanvasHeight();
    const canvas = renderer.domElement;
    camera.aspect = window.innerWidth / height;
    camera.updateProjectionMatrix();
  }

  raycaster.setFromCamera(mouse, camera);

  const types = [
    'Origo',
    'Connection',
    'WallLine',
    'GlassMeetingSign',
    'SpecialFloor',
  ];

  const pickFilteredObjects = window.Functions.FillObjects(scene, types);
  window.SetFilterObjects(pickFilteredObjects);

  const intersects: any = raycaster.intersectObjects(pickFilteredObjects);

  const clearIntersectColor = () => {
    if (intersected.current === null) {
      return;
    }

    intersected.current.material.emissive.setHex(
      intersected.current.originalHex
    );
  };

  const updateIntersect = () => {
    const newIntersected = intersects[0].object;

    if (newIntersected.originalHex === undefined) {
      newIntersected.originalHex = newIntersected.material.emissive.getHex();
    }

    newIntersected.material.emissive.setHex(0xff0000);
    intersected.current = newIntersected;
  };

  const handleIntersecting = () => {
    if (intersects.length > 0) {
      if (intersected === null) {
        updateIntersect();
        return;
      }

      if (intersected.uuid !== intersects[0].object.uuid) {
        clearIntersectColor();
        updateIntersect();
      }

      return;
    }

    if (intersected) {
      clearIntersectColor();
      intersected.current = null;
    }
  };

  handleIntersecting();

  renderer.render(scene, camera);
};

export default render;
